// extracted by mini-css-extract-plugin
export default {"button--PRIMARY":"login-form_button--PRIMARY__7Btla"};